import React from 'react'
import { Case, Default, Switch } from 'react-if'
import { LinkButton } from '@/atoms/Button'
import { PayItForwardIcon } from '@/atoms/Icons/PayItForwardIcon'
import { Placeholder } from '@/atoms/Placeholder'
import { ParagraphMD } from '@/atoms/Text'
import { paths } from '@/constants/paths'
import { useRegionContext } from '@/contexts/RegionContext'
import { useGuildMember } from '@/services/GuildUserService'
import { shouldPromoteGuild } from '@/utils/GuildUtil'
import { useSafeTrack } from '@/utils/analytics'
import { Translate } from '@/utils/translate/translate-client'
import { JoinTheGuildButton } from './JoinTheGuildButton'

interface GuildLivestreamCtaProps {
  projectSlug: string
  guid: string
}

export const JoinTheGuildLivestreamCta: React.FC<GuildLivestreamCtaProps> = ({ projectSlug, guid }) => {
  const { region, loading: isLoadingRegion } = useRegionContext()
  const { isGuildMember, loading: isLoadingGuildMembership } = useGuildMember()
  const track = useSafeTrack()

  return (
    <div>
      <Switch>
        <Case condition={isLoadingRegion || isLoadingGuildMembership}>
          <Placeholder className="h-[42px] w-[190px]" />
        </Case>
        <Case condition={isGuildMember || !shouldPromoteGuild({ region })}>
          <LinkButton
            className="min-w-[190px] rounded"
            onClick={() => {
              track('Livestream CTA Clicked', { cta: 'pif', projectSlug })
            }}
            href={`${paths.payItForward.index}/${projectSlug}`}
            prefetch={false}
            variant="oxide-bright"
            target="_blank"
          >
            <div className="mx-auto flex flex-row justify-center">
              <PayItForwardIcon color="black" className="mr-2" />
              <ParagraphMD color="black" className="whitespace-nowrap">
                <Translate ns="livestream" i18nKey="payItForwardv2">
                  Pay it Forward
                </Translate>
              </ParagraphMD>
            </div>
          </LinkButton>
        </Case>
        <Default>
          <JoinTheGuildButton projectSlug={projectSlug} guid={guid} />
        </Default>
      </Switch>
    </div>
  )
}
